import { pascalEnumToString } from "./jbhTextFormatterUtil";
import { receiveStatus } from "./receiveStatus";

export function statusToColour(status) {
	if (!status) {
		return "";
	}

	switch (status) {
		case receiveStatus.open:
		case "Released":
			return "#673ab7";
		default:
		case receiveStatus.inProgress:
			return "grey";
		case receiveStatus.pendingReview:
			return "#ff9800";
		case "PartReceived":
			return "#e91e63";
		case receiveStatus.pendingFinalise:
		case "FullyReceived":
			return "#2196f3";
		case receiveStatus.completed:
			return "#4caf50";
		case receiveStatus.cancelled:
			return "#f44336";
		case receiveStatus.receivedDirectly:
			return "#8bc34a";
		case receiveStatus.arrived:
			return "#0000ff";
	}
}

export function statusToLabel(status) {
	let label = status;
	if (status === receiveStatus.pendingFinalise) {
		label = "Pending Finalise";
	}
	if (status === receiveStatus.cancelled) {
		label = "Cleared";
	}
	return pascalEnumToString(label);
}
